import './checkbox.scss';
import {Paragraph} from "../../Elements/Paragraph";
import {I18NParagraph} from "../../Elements/I18NParagraph";
import type { CheckboxProps } from "./Checkbox.interface";

/**
 * Primary UI component for user interaction
 */
export function Checkbox(props:CheckboxProps) {

  const handleChange = () => props.checked ? props.setChecked(false) : props.setChecked(true);
  
  return (
      <div className={["checkbox-wrapper", props.className].join(" ")}>
        <div className={"checkbox-input"}>
          <div className="input">
            <input aria-label={props.id} id={props.id} type="checkbox" checked={props.checked} onChange={handleChange}/>
          </div>
          <div className="text">
            <label aria-label={props.id} htmlFor={props.id}>
              <Paragraph text={props.label} className={props.bold ? "strong" : ""}/>
            </label>
          </div>
        </div>
        { props.error &&
            <div id={props.id ? props.id + "-error" : undefined} className="checkbox_message">
              <div className="checkbox_corner error"/>
              <I18NParagraph
                  className="checkbox_text error"
                  i18n={props.error}
              />
            </div>
        }
        { props.warning &&
            <div id={props.id ? props.id + "-warning" : undefined} className="checkbox_message">
              <div className="checkbox_corner warning"/>
              <I18NParagraph
                  className="checkbox_text warning"
                  i18n={props.warning}
              />
            </div>
        }
      </div>
  );
}
